import React, { createContext, useState, useContext } from "react";

const PortfolioFilterContext = createContext();

export function PortfolioFilterProvider({ children }) {
    const [activeCategory, setActiveCategory] = useState("Imagenologia");

    return (
        <PortfolioFilterContext.Provider value={{ activeCategory, setActiveCategory }}>
            {children}
        </PortfolioFilterContext.Provider>
    );
}

export function usePortfolioFilter() {
    return useContext(PortfolioFilterContext);
}
